import CLIInject from "../../../../contents/docs/error-tracking/_snippets/cli/inject.mdx";
import * as React from 'react';
export default {
  CLIInject,
  React
};